<template>
  <v-container
    class="products-list-page"
    fluid>
    <v-row class="products-row">
      <v-col cols="12">
        <v-row>
          <v-col cols="3">
            <v-select
              v-model="selectedDraft"
              :items="sortingDraft"
              item-text="name"
              return-object
              color="secondary"
              dense
              outlined
              hide-details />
          </v-col>
          <v-col
            v-if="selectedDraft.id"
            cols="auto">
            <v-btn
              color="error"
              :disabled="disabledSaveBtn"
              @click="confirmDeleteDialog()">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="auto">
            <v-btn
              color="secondary"
              :disabled="disabledSaveBtn"
              @click="showDraft()">
              Save Draft
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="success"
              :disabled="disabledSaveBtn"
              @click="save()">
              Publish
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="8">
        <h3>แสดงบนเว็บ</h3>
        <div class="products-onweb-box text-center">
          <draggable
            class="d-flex flex-wrap justify-center draggable-box-onweb"
            :list="products.onWeb"
            style="margin: auto; width: fit-content;"
            group="products">
            <product-card
              v-for="(product, index) in products.onWeb"
              :key="`products-rest-${index}`"
              class="pa-1"
              :product="product" />
          </draggable>
          <a
            v-if="products.onWeb.length > 0"
            class="my-2 text-decoration-underline"
            :disabled="disabledLoadMoreOnWebBtn"
            @click="loadMoreProducts('onWeb')">
            Load More
          </a>
        </div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <h3>พักไว้ก่อน</h3>
            <div class="products-rest-box ">
              <draggable
                class="d-flex flex-wrap justify-center draggable-box"
                :list="products.rest"
                group="products">
                <product-card
                  v-for="(product, index) in products.rest"
                  :key="`products-${index}`"
                  :img-width="'80px'"
                  :img-height="'120px'"
                  class="pa-1"
                  :product="product" />
              </draggable>
            </div>
          </v-col>

          <v-col cols="12">
            <h3>ซ่อนจากเว็บ</h3>
            <search-by-tags
              v-model="searchByTagsValue"
              append-icon="mdi-magnify"
              :tags="tags"
              @on-search="searchHideOnweb()" />
          </v-col>
          <v-col cols="12">
            <div class="products-offweb-box text-center">
              <draggable
                class="d-flex flex-wrap justify-center draggable-box"
                :list="products.hideFromWeb"
                group="products">
                <product-card
                  v-for="(product, index) in products.hideFromWeb"
                  :key="`products-hide-${index}`"
                  :img-width="'80px'"
                  :img-height="'120px'"
                  class="pa-1"
                  :product="product" />
              </draggable>
              <a
                v-if="products.hideFromWeb.length > 0"
                class="my-2"
                :disabled="disabledLoadMoreHideFromWebBtn"
                @click="loadMoreProducts('hideFromWeb')">
                More...
              </a>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <sorting-draft-form
      v-if="isShowDraftForm"
      v-model="formData"
      @on-submit="draft()"
      @on-close="closeDraft()" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import Draggable from 'vuedraggable'
import ProductProvider from '@/resources/ProductProvider'
import SortingDraftProvider from '@/resources/SortingDraft.provider'
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'
import SearchByTags from '@/components/SearchByTags.vue'
import ProductCard from '../components/ProductCard.vue'
import SortingDraftForm from '../components/SortingDraftForm.vue'

const ProductService = new ProductProvider()
const ProductAttributeService = new ProductAttributeProvider()
const SortingDraftService = new SortingDraftProvider()

export default {
  components: {
    Draggable,
    ProductCard,
    SearchByTags,
    SortingDraftForm
  },
  data () {
    return {
      searchByTagsValue: {
        search: '',
        tags: [],
        tagOperation: 'OR',
        brand: 'Gentlelittlewoman'
      },
      isShowDraftForm: false,
      selectedDraft: {
        id: null,
        name: 'Create sorting draft',
        productsMemo: [],
        hideFormWeb: [],
        onWeb: [],
        rest: [],
        brand: 'Gentlelittlewoman'
      },
      formData: {
        id: null,
        name: '',
        productsMemo: [],
        hideFormWeb: [],
        onWeb: [],
        rest: [],
        brand: 'Gentlelittlewoman'
      },
      sortingDraft: [],
      tags: [],
      products: {
        onWeb: [],
        hideFromWeb: [],
        rest: []
      },
      productsMemo: [],
      paginate: {
        onWeb: {
          page: 1,
          lastPage: 2,
          itemsPerPage: 50,
          sortDesc: [false],
          sortBy: ['priority'],
          isOnWeb: true,
          brand: 'Gentlelittlewoman'
        },
        hideFromWeb: {
          page: 1,
          lastPage: 2,
          itemsPerPage: 30,
          search: '',
          sortDesc: [false],
          sortBy: ['updatedAt'],
          isOnWeb: false,
          brand: 'Gentlelittlewoman'
        }
      }
    }
  },
  computed: {
    disabledSaveBtn () {
      return this.products.rest.length > 0
    },
    disabledLoadMoreOnWebBtn () {
      return this.paginate.onWeb.lastPage <= this.paginate.onWeb.page
    },
    disabledLoadMoreHideFromWebBtn () {
      return this.paginate.hideFromWeb.lastPage <= this.paginate.hideFromWeb.page
    }
  },
  watch: {
    async selectedDraft () {
      if (!this.selectedDraft.id) {
        this.productsMemo = this.selectedDraft.productsMemo
        this.products.hideFromWeb = this.selectedDraft.hideFormWeb
        this.products.onWeb = this.selectedDraft.onWeb
        this.products.rest = this.selectedDraft.rest
        this.formData = { ...this.selectedDraft }

        return
      }

      const sortingDraft = await this.getSortingDraft(this.selectedDraft?.id || null)

      this.productsMemo = sortingDraft.productsMemo
      this.products.hideFromWeb = sortingDraft.hideFormWeb
      this.products.onWeb = sortingDraft.onWeb
      this.products.rest = sortingDraft.rest
      this.formData = { ...sortingDraft }
    }
  },
  async mounted () {
    await this.fetchProducts('onWeb')
    await this.getTags()
    await this.initSortingDraft()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setLoading: 'Components/setLoading',
      setModal: 'Components/setModal'
    }),
    async initSortingDraft () {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'GET SORTING DRAFT...'
        })
        this.sortingDraft = [
          {
            id: null,
            name: 'Create sorting draft',
            productsMemo: this.productsMemo,
            hideFormWeb: this.products.hideFromWeb,
            onWeb: this.products.onWeb,
            rest: this.products.rest,
            brand: 'Gentlelittlewoman'
          }
        ]
        const { data } = await SortingDraftService.getSortingDraft({ brand: 'Gentlelittlewoman' })

        if (data) {
          this.sortingDraft.push(...data)
        }
      } catch (error) {
        console.error('initSortingDraft', error)
        this.setSnackbar({
          value: true,
          message: `[INIT-SORTING-DRAFT-ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    async getSortingDraft (id) {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'GET SORTING DRAFT...'
        })

        const { data } = await SortingDraftService.getSortingDraftById(id)

        return data
      } catch (error) {
        console.error('initSortingDraft', error)
        this.setSnackbar({
          value: true,
          message: `[INIT-SORTING-DRAFT-ERROR]: ${error.message}`,
          type: 'error'
        })
        return null
      } finally {
        this.setLoading({ active: false })
      }
    },
    showDraft () {
      this.formData = { ...this.selectedDraft }
      this.isShowDraftForm = true
    },
    closeDraft () {
      this.isShowDraftForm = false
    },
    confirmDeleteDialog () {
      this.setModal({
        value: true,
        title: 'Remove Sorting Draft',
        message: 'Do you want to remove the sorting draft',
        confirmText: 'Remove',
        confirmType: 'error',
        cancelType: '',
        cancelText: 'Cancel',
        onConfirm: () => this.deleteDraft()
      })
    },
    async deleteDraft () {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'DELETE DRAFT...'
        })

        if (this.selectedDraft.id) {
          await SortingDraftService.deleteSortingDraft(this.selectedDraft.id)

          this.setSnackbar({
            value: true,
            message: 'Delete draft success.',
            type: 'success'
          })
        }

        this.isShowDraftForm = false
        this.$router.go(0)
      } catch (error) {
        console.error('draft', error)
        this.setSnackbar({
          value: true,
          message: `[DRAFT-ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    async draft () {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'UPDATING DRAFT...'
        })

        this.formData.hideFormWeb = this.products.hideFromWeb.map((p) => ({
          id: p.id,
          name: p.name,
          model: p.model,
          photoUrls: p.photoUrls,
          priority: p.priority,
          isOnWeb: p.isOnWeb
        }))

        this.formData.onWeb = this.products.onWeb.map((p) => ({
          id: p.id,
          name: p.name,
          model: p.model,
          photoUrls: p.photoUrls,
          priority: p.priority,
          isOnWeb: p.isOnWeb
        }))

        this.formData.rest = this.products.rest.map((p) => ({
          id: p.id,
          name: p.name,
          model: p.model,
          photoUrls: p.photoUrls,
          priority: p.priority,
          isOnWeb: p.isOnWeb
        }))

        this.formData.productsMemo = this.productsMemo.map((p) => ({
          id: p.id,
          name: p.name,
          model: p.model,
          photoUrls: p.photoUrls,
          priority: p.priority,
          isOnWeb: p.isOnWeb
        }))

        this.formData.brand = 'Gentlelittlewoman'

        if (this.formData.id) {
          await SortingDraftService.updateSortingDraft(this.formData)

          this.setSnackbar({
            value: true,
            message: 'Update draft success.',
            type: 'success'
          })
        } else if (this.isShowDraftForm) {
          await SortingDraftService.createSortingDraft(this.formData)

          this.setSnackbar({
            value: true,
            message: 'Create draft success.',
            type: 'success'
          })
        }

        this.isShowDraftForm = false
        this.$router.go(0)
      } catch (error) {
        console.error('draft', error)
        this.setSnackbar({
          value: true,
          message: `[DRAFT-ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    async save () {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'UPDATING PRIORITY...'
        })

        const onWeb = this.mapForUpdatePriority()
        const hideFromWeb = this.findWhichToHideOnWeb()
        const newOnWeb = this.findNewOnWeb()
        const diff = newOnWeb.length - hideFromWeb.length

        await Promise.all([
          this.updatePriorityAndIsOnWeb({ products: onWeb, diff }),
          this.updatePriorityAndIsOnWeb({ products: hideFromWeb })
        ])

        if (this.selectedDraft.id) {
          await SortingDraftService.deleteSortingDraft(this.selectedDraft.id)
        }

        this.$router.go(0)
      } catch (error) {
        console.error('save', error)
        this.setSnackbar({
          value: true,
          message: `[SAVE-ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    findNewOnWeb () {
      const results = []
      for (const product of this.products.onWeb) {
        const found = this.productsMemo.findIndex((each) => each.id === product.id)
        if (found === -1) {
          results.push({
            id: product.id,
            isOnWeb: false
          })
        }
      }

      return results
    },
    findWhichToHideOnWeb () {
      const results = []
      for (const product of this.productsMemo) {
        const found = this.products.onWeb.findIndex((each) => each.id === product.id)
        if (found === -1) {
          results.push({
            id: product.id,
            isOnWeb: false
          })
        }
      }

      return results
    },
    async updatePriorityAndIsOnWeb (payloads) {
      try {
        await ProductService.updatePriorityAndIsOnWeb(payloads)
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `[UPDATING-PRODUCT-ERROR]: ${error.message}`,
          type: 'error'
        })
      }
    },
    mapForUpdatePriority () {
      return this.products.onWeb.map((product, index) => ({
        priority: index,
        id: product.id,
        isOnWeb: true
      }))
    },
    loadMoreProducts (state) {
      const { page, lastPage } = this.paginate[state]

      if (page < lastPage) {
        this.paginate[state] = {
          ...this.paginate[state],
          tags: this.searchByTagsValue.tags,
          tagOperation: this.searchByTagsValue.tagOperation,
          search: this.searchByTagsValue.search,
          brand: this.searchByTagsValue.brand,
          page: this.paginate[state].page + 1
        }

        this.fetchProducts(state)
      }
    },
    async fetchProducts (state) {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'GETTING PRODUCT...'
        })

        const { data } = await ProductService.getProductsForSorting(this.paginate[state])
        this.paginate[state].lastPage = data.pages
        this.products[state].push(...data.results)

        if (state === 'onWeb') {
          this.productsMemo.push(...data.results)
        }
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `[GET-PRODUCT-ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    async searchHideOnweb () {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'GETTING PRODUCT...'
        })

        this.paginate.hideFromWeb.search = this.searchByTagsValue.search

        const { data } = await ProductService.getProductsForSorting({
          ...this.paginate.hideFromWeb,
          page: 1,
          lastPage: 2,
          tags: this.searchByTagsValue.tags,
          tagOperation: this.searchByTagsValue.tagOperation,
          brand: 'Gentlelittlewoman'
        })
        this.paginate.hideFromWeb.lastPage = data.pages
        this.products.hideFromWeb = this.removeDupOnWeb(data.results)
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `[GET-PRODUCT-ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    removeDupOnWeb (list) {
      const result = []
      for (const each of list) {
        const dup = this.products.onWeb.findIndex((onWeb) => onWeb.id === each.id) !== -1

        if (!dup) {
          result.push(each)
        }
      }

      return result
    },
    async getTags () {
      try {
        const { data } = await ProductAttributeService.getProductAttribute('tags', {
          page: 1,
          itemsPerPage: 9999999,
          sortBy: ['id'],
          sortDesc: [true]
        })
        this.tags = data.results.map((r) => ({
          id: r.id,
          name: r.name,
          status: 'active'
        }))
      } catch (error) {
        console.error('getTags: ', error)
        this.setSnackbar({
          value: true,
          message: `[GET-TAGS-ERROR]: ${error.message}`,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style scoped>
.products-onweb-box {
  height: calc(100vh - 250px);
  border: 1px rgba(0, 0, 0, 0.2) solid;
  border-radius: 6px;
  overflow-y: auto;
}
.products-rest-box {
  height: calc(50vh - 280px);
  border: 1px rgba(0, 0, 0, 0.2) solid;
  border-radius: 6px;
  overflow-y: auto;
}
.products-offweb-box {
  height: calc(50vh - 110px);
  border: 1px rgba(0, 0, 0, 0.2) solid;
  border-radius: 6px;
  overflow-y: auto;
}
.draggable-box {
  min-height: 87%;
}

.draggable-box-onweb {
  min-height: 33%;
}
.load-more-icon-box {
  padding: 16px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.search-tags {
  width: 100%;
}
.search-product-container {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 1px solid darkgray;
}
</style>
